import React from 'react';
import { createIcon } from './create-icon';
import './icon-check-mark.scss';

export const IconCheckMark = createIcon(<div className="icon-check-mark" />);
